import {takeEvery,all,put,select,call} from 'redux-saga/effects';
import * as actions from './actions';
import * as selectors from './selectors';
import * as independentAmountApi from '../api/independentAmountApi';
import { searchToFilters } from '../common/urlUtils';
import actionFactory from '../webcommon/header/filterheader/actions';
import * as filterHeaderSelectors from '../webcommon/header/filterheader/selectors';
import fileDownload from 'js-file-download';
const filterHeaderId = 'IndependentAmount';

export const filterHeaderActions = actionFactory(filterHeaderId);

export function* independentAmountConnected(action){
    try {
        const initialised = yield (select(selectors.getIndependentAmountInitialised));
        if (!initialised) {
            yield put(actions.setIndependentAmountLoading(true));
            const filterDefinitions = yield select(selectors.getFilterDefinitions);
            yield put(filterHeaderActions.setFilterDefinitions(filterDefinitions));
            const defaultFilters = yield select(selectors.getDefaultFilters);
            yield put(filterHeaderActions.setDefaultFilters(defaultFilters));
            if (action.search === '') {
                yield put(filterHeaderActions.resetFilters());
            } else {
                const filters = searchToFilters(action.search, filterDefinitions, defaultFilters);
                yield put(filterHeaderActions.setFilters(filters));
            }
            yield put(actions.getIndependentAmount())

            yield put(actions.setIndependentAmountInitialised(true));
        }
    } finally {
        yield put(actions.setIndependentAmountLoading(false));
    }
}

export function* filterChanged() {
    const initialised = yield select(selectors.getIndependentAmountInitialised);
    if (initialised) {
        const currentlyOpenFilter = yield (select(filterHeaderSelectors.getCurrentlyOpenFilter, filterHeaderId));
        if (!currentlyOpenFilter) {
            const filters = yield select(filterHeaderSelectors.getFilters, filterHeaderId);
            yield put(actions.setRunDate(filters[0].value.from));
            yield put(actions.refreshIndependentAmount());
        }
    }
} 

export function* getIndependentAmount(api) {
    const filters = yield select(filterHeaderSelectors.getFilters, filterHeaderId);
    const EodDate = filters[0].value.from;

    try {        
        const result = yield call(api.getIndependentAmount, EodDate)
        yield put(actions.getIndependentAmountSuccess(result))
        

    } catch (error) {
        yield put(actions.getIndependentAmountFailed('Failed to retrieve ia results from Database'));
        
    }
    try {
        const result2 = yield call(api.getDowngradeReportAvailability, EodDate)
        const result3 = yield call(api.getOtcIaReportAvailability, EodDate)
        yield put(actions.getReportsSuccess(result2, result3))

    } catch (error){
        yield put(actions.getReportsFailed('Failed to retrieve file statuses from Database'));
    }
}

export function* exportCalcReports(api , action) {   
    try{
     const result = yield call(api.exportCalcReports, action.ids)
     console.log(action) 
     yield put(actions.exportCalcReportsSuccess(result))
 } catch (e){
     console.error("Failed to retrieve report")
     yield put(actions.exportCalcReportsFailed("Failed to retrieve report"))
 } 
    
 }

 export function* exportReport(api , action) {   
    try{
     const result = yield call(api.exportFile, action.fileInfo)
     console.log(action) 
     yield put(actions.exportReportSuccess(result))
 } catch (e){
     console.error("Failed to retrieve report")
     yield put(actions.exportReportFailed("Failed to retrieve report"))
 } 
    
 }
 
 export function* createBrowserDownload(fd, action) {
     console.log(action)
     yield call(fd, action.downloadFile.data, action.downloadFile.filename);
 }
 
export default function* rootSaga() {
    yield all([
        takeEvery(actions.INDEPENDENT_AMOUNT_LOADED, independentAmountConnected),
        takeEvery(
            [
                filterHeaderActions.UPDATE_FILTER,
                filterHeaderActions.REMOVE_FILTER,
                filterHeaderActions.RESET_FILTERS
            ], 
            filterChanged),
        takeEvery(
            [
                actions.GET_INDEPENDENT_AMOUNT, 
                actions.REFRESH_INDEPENDENT_AMOUNT
            ],
            getIndependentAmount, independentAmountApi),
        takeEvery(actions.EXPORT_INDEPENDENT_AMOUNT_REPORTS, exportCalcReports, independentAmountApi),
        takeEvery(actions.EXPORT_IA_REPORT, exportReport, independentAmountApi),

        takeEvery(
            [
                actions.EXPORT_INDEPENDENT_AMOUNT_REPORTS_SUCCESS,
                actions.EXPORT_IA_REPORT_SUCCESS
            ], createBrowserDownload, fileDownload),
        
    ]);
}